import { ConfigProvider } from "antd";
import { createContext, useContext, useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EmptyData from "../components/empty/EmptyData";
import locale from "antd/locale/fa_IR";
import GlobalLayout from "../global_layout/global_layout";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
// export const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: Infinity,
//     },
//   },
// });
const ThemeContext = createContext();
export const ThemeContextProvider = ({ children }) => {
  const [configTheme] = useState({
    bgColor: "#F9FAFB",
    textColor: "#13727D",
    bgButtonColor: "#13727D",
    textButtonColor: "#fff",
    isRTL: true,
    language: "fa",
    background: "#F9FAFB",
    fontFamily: "IRANSansX",
  });
  useEffect(() => {
    i18n.changeLanguage(configTheme.language);
  }, [configTheme.language]);

  return (
    <ThemeContext.Provider value={configTheme}>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider
          locale={locale}
          theme={{
            token: {
              fontFamily: configTheme.language === "fa" ? "IRANSansX" : "Roboto",
            },
            components: {
              Modal: {
                colorBgMask: "rgba(0, 0, 0, 0.80)",
                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
              },
            },
          }}
          renderEmpty={() => <EmptyData />}
          direction={configTheme.isRTL ? "rtl" : "ltr"}
          form={{ className: "input-normal" }}
          button={{ className: "btn-normal" }}
          modal={{ className: "myModal" }}
          checkbox={{ className: "normal-checkbox" }}
          radio={{ className: "normal-radio" }}
          tabs={{ className: "mytabs" }}
          breadcrumb={{ className: "mybreadcrumbs" }}
          table={{ className: "mytabs" }}
        >
          {/* <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={true} />
            
          </QueryClientProvider> */}
          <GlobalLayout>{children}</GlobalLayout>

          <ToastContainer />
        </ConfigProvider>
      </I18nextProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeContextProvider;
export function useTheme() {
  return useContext(ThemeContext);
}
